module.exports = __webpack_public_path__ + "img/user-center.ec63ac6a.svg";